export default "__VITE_ASSET__D8qL$_Sp__"